import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import useCustomField from '@hooks/useCustomField'
import useCustomFields from '@hooks/useCustomFields'

import CustomField from './CustomField'

const CustomFieldSet = (props) => {
  const { customFieldSet } = props

  const { entity_type, id } = customFieldSet

  const customFieldSetPayload = useCustomFields({ filters: { owner_id: id, owner_type: 'CustomFieldSet' } })

  const {
    filteredCustomFields,
    hasCustomFieldSets,
    loading,
  } = customFieldSetPayload

  const customFieldPayload = useCustomField({ owner_type: 'CustomFieldSet', owner_id: id })
  const { callbacks: { createOrEditCustomField } } = customFieldPayload

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} loading={loading} title={`${entity_type} Fields`}>
      {!loading && !hasCustomFieldSets && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Fields present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please create a Custom Field
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {!loading && hasCustomFieldSets && (
        <DashboardModule.ScrollableSection>
          {filteredCustomFields.map(customField => (
            <CustomField key={customField.id} customField={customField} />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      <DashboardModule.Footer boxProps={{ borderTop: loading ? 'none' : '1px solid' }}>
        <DashboardModule.FooterRight>
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => createOrEditCustomField()}
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Field
          </Button>
        </DashboardModule.FooterRight>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

CustomFieldSet.propTypes = {
  customFieldSet: PropTypes.object.isRequired,
}

export default CustomFieldSet
